export class ManurePadDepthType {
    id;
    manurePadDepthType;

    constructor({ id, manurePadDepthType }) {
        this.id = id;
        this.manurePadDepthType = manurePadDepthType;
    }
}